export const getRiojaAltaData = () => ({
  name: "Rioja Alta",
  country: "Espagne",
  region: "Rioja",
  description: "Rioja Alta est la sous-région la plus prestigieuse de Rioja, produisant des vins rouges élégants et équilibrés avec une complexité aromatique exceptionnelle.",
  type: "subregion",
  mapAreas: [
    { region: "Rioja Alta", x: 42, y: 32, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "25,000 ha",
    production: "100 million litres",
    wineries: "200+ bodegas",
    villages: "12 villages principaux",
    exportPercentage: "45%"
  },
  characteristics: {
    climate: "Climat continental tempéré avec influences atlantiques",
    soil: "Sols calcaires et argilo-calcaires, galets roulés",
    viticulture: "Vignes en altitude (400-600m), rendements limités"
  },
  wineStyles: {
    red: "Vins rouges élégants et équilibrés, avec des notes de vanille et de fruits rouges",
    white: "Vins blancs secs et aromatiques, principalement de Viura",
    rosé: "Rosés fruités et équilibrés"
  },
  history: "Rioja Alta est le berceau historique de la viticulture riojane. Les premières bodegas ont été fondées au XIXe siècle, introduisant les techniques bordelaises d'élevage en barriques.",
  foodPairing: "Viandes rouges, agneau, fromages affinés, tapas traditionnelles",
  grapeVarieties: [
    {
      name: "Tempranillo",
      percentage: "75%",
      description: "Cépage roi de Rioja, produisant des vins élégants et complexes",
      characteristics: "Élégant, tanins soyeux, notes de fruits rouges et de vanille",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Garnacha",
      percentage: "15%",
      description: "Cépage d'assemblage, apportant fruité et chaleur",
      characteristics: "Fruité, alcool élevé, notes d'épices",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Graciano",
      percentage: "5%",
      description: "Cépage d'assemblage, apportant structure et acidité",
      characteristics: "Structuré, acidité vive, notes de violette",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Mazuelo",
      percentage: "3%",
      description: "Cépage d'assemblage, apportant couleur et tanins",
      characteristics: "Coloré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Viura",
      percentage: "2%",
      description: "Cépage blanc principal pour les vins blancs",
      characteristics: "Sec, aromatique, notes d'agrumes",
      wineStyles: "Sec, léger, aromatique"
    }
  ]
}); 